<template>
  <div>
    <header class="page-header">
      <PageTitle/>
    </header>

    <div class="main-content">
      <div class="pane table-pane" :class="{'loading': isLoading}">
        <div class="table-wrapper">
          <div class="table-element">
            <table class="listData" v-if="!isLoading">
              <thead>
              <tr :key="key" v-for="(value, key) in listData">
                <th>{{ key }}</th>
              </tr>
              </thead>

              <tbody v-if="Object.keys(listData).length > 0">
              <tr :key="key" v-for="(value, key) in listData">
                <td>
                  <formulate-input @keydown.enter="editSetting" v-model="listData[key]"></formulate-input>
                </td>
              </tr>
              </tbody>
            </table>
          </div>

          <div class="pagination">
            <div class="results">
              {{ Object.keys(listData).length }} instellingen
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { ApiService } from '@/services/admin/api.service'
import PageTitle from '@/components/admin/PageTitle'

export default {
  components: { PageTitle },
  data: function () {
    return {
      isLoading: true,
      listData: [],
      editValue: null,
      editId: null
    }
  },
  async mounted () {
    this.isLoading = true
    await this.getListData()
    this.isLoading = false
  },
  methods: {
    async getListData () {
      await ApiService.fetchCalculatorSettings().then(res => {
        this.listData = res.data
      })
    },
    async editSetting () {
      await ApiService.patchCalculatorSetting(1, this.listData).then(res => {

      })
    }
  }
}
</script>
